













































import { BAlert } from 'bootstrap-vue';
import Vue from 'vue';
import { mapActions } from 'vuex';
import { get, isArray, join } from 'lodash';

import { ZenFormGroup } from 'zenComponents';
import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

import attrMutationQuery from '@/graphql/listing/edit/AttributeMutation';

// New object imports
// TODO refactor new object
import presenterData from '@/pages/sor/new_object/object_form_data';
import * as FieldPresenters from '@/pages/sor/new_object/components/field_presenters';
import { createVuelidateObject, getErrorMessage } from '@/pages/sor/new_object/utils';
import { DEFAULT_ERROR_MESSAGE } from '@/pages/sor/new_object/constants';

export default Vue.extend({
  name: 'EditCard',
  components: {
    BAlert,
    GenericCard,
    LoadingState,
    ZenFormGroup,
    ...FieldPresenters,
  },
  props: {
    objects: {
      type: Array as () => string[],
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    // TODO query for fresh data instead of passing it as prop
    data: {
      type: Object,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    // TODO: Use modelMeta
    const presenterInfo = presenterData(this.objectType).attrMapper[this.column.customAttributeType || this.column.key];
    let newValue = this.data.value;
    const multiple = get(presenterInfo, 'renderInfo.presenterAttributes.multiple', false);

    if (newValue && get(presenterInfo, 'extraInfo.editValueParser')) {
      newValue = presenterInfo.extraInfo.editValueParser(this.data, multiple);
    }

    return {
      ignoreWarnings: <boolean>false,
      loading: <boolean>false,
      saving: <boolean>false,
      newValue,
      presenterInfo,
      multiple,
      forcedFieldErrors: null,
    };
  },
  validations() {
    return {
      // TODO: Refactor the shit out of this
      newValue: this.vuelidateObject,
    };
  },
  computed: {
    vuelidateObject() {
      if (!this.attribute.name) {
        return {};
      }
      return createVuelidateObject([this.attribute])[this.attribute.name];
    },
    attribute() {
      return this.objectAttributeData ? this.objectAttributeData.attrs[0] : {};
    },
    validationData() {
      if (this.forcedFieldErrors) {
        // TODO: this should be moved to form presenter when we clean up that code
        const forcedFieldErrors = isArray(this.forcedFieldErrors)
          ? join(this.forcedFieldErrors, ', ')
          : this.forcedFieldErrors;

        return {
          isValid: false,
          errorMessage: forcedFieldErrors || DEFAULT_ERROR_MESSAGE,
        };
      }

      const validationInfo = this.$v.newValue;
      const { $dirty, $invalid, $pending } = validationInfo;
      const errorMessage = getErrorMessage(this.attribute.validation, validationInfo);

      return {
        isValid: $dirty && !$pending ? !$invalid : null,
        errorMessage,
      };
    },
    warningMessage(): string | '' {
      if (this.attribute && this.attribute.name && this.attribute.name.startsWith('dynamic__risk_factor')) {
        return 'You will need to manually recalculate risk scores after you\'ve changed risk factors.';
      } else {
        return '';
      }
    },
  },
  created() {
    const size = this.column.key === 'description' ? ModalSize.Medium : ModalSize.Small;
    this.changeModalSize(size);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
    }),
    async saveAttributeValue() {
      this.saving = true;
      let val = this.newValue;
      if (get(this.presenterInfo, 'extraInfo.submissionDataParser')) {
        val = this.presenterInfo.extraInfo.submissionDataParser(this.newValue);
      }

      await Promise.allSettled(
        this.objects.map(object => {
          let query = attrMutationQuery(this.objectType, object, this.attribute, val);

          return this.$apollo
            .mutate({
              mutation: query.mutation,
              variables: query.variables,
            })
            .catch(err => {
              throw err;
            });
        })
      )
        .then(result => {
          const rejected = result.filter(el => el.reason);
          const accepted = result.filter(el => el.value);

          if (rejected.length) {
            let userFriendlyErrors = rejected.map(r => {
              if (
                r.reason.graphQLErrors &&
                r.reason.graphQLErrors.length &&
                r.reason.graphQLErrors[0].extensions.errors
              ) {
                return `- ${r.reason.graphQLErrors[0].extensions.errors[0].user_message}`;
              }
            });
            userFriendlyErrors.unshift('An error occurred while saving.');
            const toAlertMessage = (vals: string[]) => join(vals, '<br>');
            const message = toAlertMessage(userFriendlyErrors);

            this.showAlert({
              type: 'error',
              message,
            });
          }

          if (accepted.length) {
            this.confirmModal();
            this.showAlert({
              type: 'success',
              message: 'Attribute updated succesfully',
            });
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    valueChangeHandler() {
      this.forcedFieldErrors = null;
      this.$v.newValue.$touch();
    },
  },
  apollo: {
    objectAttributeData: {
      query: require('@/graphql/listing/edit/AttributeInfo.gql'),
      variables() {
        return {
          type: this.objectType,
          attr: this.column.key,
        };
      },
      error() {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      },
    },
  },
});
